
<div class="badge" [class.small]="size() === 'small'" [class.large]="size() === 'large'" [style]="getIndividualBadgeStyle()">
  @switch (status()) {
    @case ('doneManually') {
      <img src="assets/icons/check_mark.svg" alt="Done" width="11" height="11" />
    }
    @case ('doneAutomatically') {
      <img src="assets/icons/ai_magic.svg" alt="Done" width="11" height="11" />
    }
    @case ('open') {}
    @case ('next') {
      <img src="assets/icons/play_triangle.svg" alt="Done" width="11" height="11" />
    }
  }
</div>
